import apiClient, { unwrap } from './client';

// Backend uses `reason`; frontend uses `cause`
function toFrontend(record) {
  return { ...record, cause: record.reason ?? record.cause ?? '' };
}

function toRequest(record) {
  const { cause, ...rest } = record;
  return { ...rest, reason: cause ?? rest.reason };
}

export const mortalityApi = {
  getAll: async () => {
    const res = await apiClient.get('/mortality-records', { params: { size: 1000, sort: 'date,desc' } });
    const page = unwrap(res);
    return (page?.content ?? page ?? []).map(toFrontend);
  },

  create: async (record) => {
    const res = await apiClient.post('/mortality-records', toRequest(record));
    return toFrontend(unwrap(res));
  },

  update: async (id, record) => {
    const res = await apiClient.put(`/mortality-records/${id}`, toRequest(record));
    return toFrontend(unwrap(res));
  },

  remove: async (id) => {
    await apiClient.delete(`/mortality-records/${id}`);
  },
};
